import React from "react";
import styled from "styled-components";
import { Paper, Typography, Divider } from "@mui/material";
import { addDays } from "date-fns";
import { PieChart, Calendar, Cast } from "react-feather";
import { ShowState } from "../../../styles";
import {
  getDaysOpen,
  addCommas,
  getSrcTwo,
} from "../../../../../storage/helpers";
import {
  FlexDivTwo,
  MainContentContainer,
  SmallText,
  OverSized,
  ThirdContainer,
} from "../../reportStyles";
import ShowSelectedRetailAudience from "./ShowSelectedRetailAudience";

const Spacer = styled.div`
  height: 16px;
  background: transparent;
`;

const Wrapper = styled(Paper)`
  width: 100%;
  min-height: 200px;
  padding: 20px;
  border-radius: 4px;
`;

const FlexDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -8px;
`;

const ModuleImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: 38px;
    width: 38px;
    margin-right: 8px;
    border-radius: 4px;
    border: 1px solid #eeeeee;
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    span {
      font-size: 11px;
      color: ${(props) => props.theme.palette.grey[600]};
      margin-top: -2px;
    }
  }
`;

const getSummaryStats = (submissions, completions) => {
  return {
    numFailed: submissions - completions,
    passRate:
      !completions || !submissions
        ? 0
        : Math.floor((completions / submissions) * 100),
  };
};

const QuizDetails = ({ quiz, submissions, completions }) => {
  const diff = getDaysOpen(quiz.startDate, quiz.dueDate);

  const cleanStartDate = quiz.startDate
    ? addDays(new Date(quiz.startDate), 1)
    : null;
  const cleanEndDate = quiz.dueDate ? addDays(new Date(quiz.dueDate), 1) : null;

  const { numFailed, passRate } = getSummaryStats(submissions, completions);

  return (
    <>
      <Wrapper>
        <FlexDiv>
          <ModuleImageWrapper>
            <img src={getSrcTwo(quiz.image, true)} alt="module" />
            <div>
              <Typography variant="h5">{quiz.name}</Typography>
            </div>
          </ModuleImageWrapper>
          <ShowState $state={quiz.state}>
            <span>{quiz.state}</span>
          </ShowState>
        </FlexDiv>
        <Divider sx={{ mt: 1, mb: 1 }} />
        <MainContentContainer>
          <ThirdContainer>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 4,

                marginBottom: 8,
                marginTop: 8,
              }}
            >
              <Calendar height={12} width={12} color="darkgrey" />
              <span
                style={{ color: "darkgray", fontWeight: "600", fontSize: 11 }}
              >
                DATES
              </span>
            </div>

            <FlexDivTwo>
              <SmallText>Start Date</SmallText>
              <OverSized>
                {quiz.startDate ? cleanStartDate.toDateString() : "None"}
              </OverSized>
            </FlexDivTwo>
            <FlexDivTwo>
              <SmallText>End Date</SmallText>
              <OverSized>
                {quiz.dueDate ? cleanEndDate.toDateString() : "None"}
              </OverSized>
            </FlexDivTwo>
            <FlexDivTwo>
              <SmallText>Days Open</SmallText>
              <OverSized>{`${diff} Days`}</OverSized>
            </FlexDivTwo>
          </ThirdContainer>
          <ThirdContainer>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 4,
                marginBottom: 8,
                marginTop: 8,
              }}
            >
              <PieChart height={12} width={12} color="darkgrey" />
              <span
                style={{ color: "darkgray", fontWeight: "600", fontSize: 11 }}
              >
                STATS
              </span>
            </div>
            <FlexDivTwo>
              <SmallText>Total Submissions</SmallText>
              <OverSized>{addCommas(submissions)}</OverSized>
            </FlexDivTwo>
            <FlexDivTwo>
              <SmallText>Completions</SmallText>
              <OverSized>{addCommas(completions)}</OverSized>
            </FlexDivTwo>
            <FlexDivTwo>
              <SmallText>Failed Attempts</SmallText>
              <OverSized>{addCommas(numFailed)}</OverSized>
            </FlexDivTwo>
            <FlexDivTwo>
              <SmallText>Pass Rate</SmallText>
              <OverSized>{passRate}%</OverSized>
            </FlexDivTwo>
          </ThirdContainer>
          <ThirdContainer>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 4,
                marginBottom: 8,
                marginTop: 8,
              }}
            >
              <Cast height={12} width={12} color="darkgrey" />
              <span
                style={{ color: "darkgray", fontWeight: "600", fontSize: 11 }}
              >
                AUDIENCE
              </span>
            </div>
            <ShowSelectedRetailAudience id={quiz.id} />
          </ThirdContainer>
        </MainContentContainer>
      </Wrapper>
      <Spacer />
    </>
  );
};

export default QuizDetails;
